var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overhead-desktop__wrapper"},_vm._l((_vm.getOverheadLayout),function(item){return _c('overhead-window',{key:item.i,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }